import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

const HomePage = lazy(() => import('./pages/HomePage'));
const BlogPage = lazy(() => import('./pages/BlogPage'));
const ToolsPage = lazy(() => import('./pages/ToolsPage'));
const SketchStudioPage = lazy(() => import('./pages/SketchStudioPage'));
const GamesPage = lazy(() => import('./pages/GamesPage'));
const LexiCrushPage = lazy(() => import('./pages/LexiCrushPage'));

const PageLoader: React.FC = () => (
  <div style={{
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '60vh',
    color: '#7E7367',
    fontFamily: 'system-ui, -apple-system, sans-serif',
    fontSize: '15px',
    fontWeight: 600
  }}>
    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
      <div style={{
        width: '18px',
        height: '18px',
        borderRadius: '50%',
        border: '2px solid #E06D53',
        borderTopColor: 'transparent',
        animation: 'spin 0.8s linear infinite'
      }} />
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
      <span>Loading...</span>
    </div>
  </div>
);

function App() {
  return (
    <Router>
      <div>
        <Suspense fallback={<PageLoader />}>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/blog/*" element={<BlogPage />} />
            <Route path="/tools" element={<ToolsPage />} />
            <Route path="/tools/:toolId" element={<ToolsPage />} />
            <Route path="/sketch-studio" element={<SketchStudioPage />} />
            
            {/* LexiCrush Saga Vocabulary Match-3 */}
            <Route path="/lexicrush" element={<LexiCrushPage />} />
            <Route path="/vocab-crush" element={<LexiCrushPage />} />
            <Route path="/games/vocab-crush" element={<LexiCrushPage />} />
            <Route path="/games/lexicrush" element={<LexiCrushPage />} />

            {/* PlayHub Casual Games Platform */}
            <Route path="/games/*" element={<GamesPage />} />
            <Route path="/playhub/*" element={<Navigate to="/games" replace />} />
            <Route path="/game/*" element={<Navigate to="/games" replace />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Suspense>
      </div>
    </Router>
  );
}

export default App;

